import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import styles from './BirdsnestRangeSlider.module.scss';
export function BirdsnestRangeSlider({ min, max, gap, currentMin, currentMax, unit = '$', onChange }) {
    const [values, setValues] = useState({
        min: currentMin,
        max: currentMax,
    });
    useEffect(() => {
        setValues({
            min: currentMin,
            max: currentMax,
        });
    }, [currentMin, currentMax]);
    const handleMinSliderChange = (e) => {
        const newMin = parseInt(e.target.value, 10);
        if (newMin <= values.max - gap) {
            setValues(prev => (Object.assign(Object.assign({}, prev), { min: newMin })));
        }
    };
    const handleMaxSliderChange = (e) => {
        const newMax = parseInt(e.target.value, 10);
        if (newMax >= values.min + gap) {
            setValues(prev => (Object.assign(Object.assign({}, prev), { max: newMax })));
        }
    };
    const handleMinInputChange = (e) => {
        const newMin = parseInt(e.target.value, 10) || 0;
        setValues(prev => (Object.assign(Object.assign({}, prev), { min: Math.min(newMin, prev.max - gap) })));
    };
    const handleMaxInputChange = (e) => {
        const newMax = parseInt(e.target.value, 10) || max;
        setValues(prev => (Object.assign(Object.assign({}, prev), { max: Math.max(newMax, prev.min + gap) })));
    };
    const handleBlur = () => {
        onChange([values.min, values.max]);
    };
    const minPercent = ((values.min - min) / (max - min)) * 100;
    const maxPercent = ((values.max - min) / (max - min)) * 100;
    return (h("div", { class: styles.rangeSlider },
        h("div", { class: styles.sliderContainer },
            h("div", { class: styles.sliderTrack },
                h("div", { class: styles.sliderRange, style: {
                        left: `${minPercent}%`,
                        width: `${maxPercent - minPercent}%`
                    } })),
            h("input", { type: "range", min: min, max: max, step: gap, value: values.min, onInput: handleMinSliderChange, onMouseUp: handleBlur, onTouchEnd: handleBlur, class: styles.sliderInput }),
            h("input", { type: "range", min: min, max: max, step: gap, value: values.max, onInput: handleMaxSliderChange, onMouseUp: handleBlur, onTouchEnd: handleBlur, class: styles.sliderInput })),
        h("div", { class: styles.inputContainer },
            h("div", { class: styles.inputGroup },
                h("span", { class: styles.inputUnit }, unit),
                h("input", { type: "number", min: min, max: max, value: values.min, onChange: handleMinInputChange, onBlur: handleBlur, class: styles.input })),
            h("div", { class: styles.inputGroup },
                h("span", { class: styles.inputUnit }, unit),
                h("input", { type: "number", min: min, max: max, value: values.max, onChange: handleMaxInputChange, onBlur: handleBlur, class: styles.input })))));
}
